module.exports = __webpack_public_path__ + "client_dashboard.gif?e74883232521ce5c92f7cf09c6bda105";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newborn/client_dashboard.gif
// module id = 374
// module chunks = 0